/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 18:29:25
 * @LastEditTime: 2021-11-02 11:30:01
 * @LastEditors: wangshengqiang
 * @Description: 开户名称
 */
import React, { useEffect } from 'react';
import { useStore } from '@/store';
import RowInput from '../RowInput';

const BankAccountName = props => {
  const {
    formKey,
    form
  } = props;
  const name = useStore('formValues.holder.name');
  useEffect(() => {
    if (name) {
      form.setFieldsValue({
        [`${formKey}`]: name
      });
    }
  }, [name]);
  return /*#__PURE__*/React.createElement(RowInput, props);
};

export default BankAccountName;